import Svg from 'react-native-svg';
import { ICON_NAMES as iconNamesV2 } from 'src/components/icon/icon.helper';
import { ICON_NAMES as iconNamesV3 } from 'src/editor-v3/components/icon/icon.helper';

export type IconName = keyof typeof iconNamesV2 | keyof typeof iconNamesV3;

export type LazyIconProps = {
  name: IconName;
  filled?: boolean;
  width?: number | string;
  height?: number | string;
  color?: string;
  colors?: string[];
  ref?: React.ForwardedRef<Svg>;
  testID?: string;
  type?: IconType;
  iconLibrary: Partial<Record<IconName, React.ComponentType<any>>>;
};

export enum IconType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  PLACEHOLDER = 'placeholder',
  INTERACTIVE = 'interactive',
  BRAND = 'brand',
  PROMO = 'promo',
  DELIVERY = 'delivery',
  SUCCESS = 'success',
  ALERT = 'alert',
  ERROR = 'error',
  DISABLED = 'disabled',
  ON_DARK = 'on-dark',
  INVERTED = 'inverted',
}
